export default __webpack_public_path__ + "static/media/spaceStation5.ca36b230.webp";